import { useState } from "react";
import { Alert, Text } from "@mantine/core";
import { FiAlertTriangle } from "react-icons/fi";
import { useAppSelector } from "../app/hooks";
import { selectDuplicateSpaces } from "../McBim/spaceDuplicateSelectors";

export const DuplicateSpacesBanner = () => {
  const duplicates = useAppSelector(selectDuplicateSpaces);
  const [dismissedDuplicates, setDismissedDuplicates] = useState<typeof duplicates | null>(null);
  if (duplicates.length === 0 || duplicates === dismissedDuplicates) return null;

  return (
    <Alert
      color="red"
      variant="light"
      radius={0}
      icon={<FiAlertTriangle size={26} />}
      title={`Ugyldig romgrunnlag: ${duplicates.length} romnummer forekommer flere ganger`}
      role="alert"
      withCloseButton
      closeButtonLabel="Lukk advarsel"
      onClose={() => setDismissedDuplicates(duplicates)}
      p="md"
      style={{ flexShrink: 0, borderBottom: "2px solid var(--mantine-color-red-6)" }}
    >
      <Text size="sm">
        Multiplacer forutsetter at hvert romnummer er unikt i prosjektet. Duplikater kan gi feil
        i romvalg, komponentplassering, validering og beregninger. Resultatene kan ikke regnes som
        pålitelige før romgrunnlaget er rettet.
      </Text>
      <Text size="sm" mt={4}>
        Kontroller kildefilene og prosjektets filliste i MCBIM, og fjern overlappende romdata før
        du arbeider videre. Romsøk er midlertidig deaktivert for å unngå krasj.
      </Text>
      <details style={{ marginTop: 8 }}>
        <summary style={{ cursor: "pointer", fontWeight: 600 }}>
          Vis berørte rom og IFC-filer
        </summary>
        <div style={{ maxHeight: 160, overflow: "auto", marginTop: 8 }}>
          {duplicates.map((room) => (
            <Text key={room.roomNumber} size="sm" style={{ overflowWrap: "anywhere" }}>
              <strong>{room.roomNumber}</strong> · {room.count} forekomster ·{" "}
              {room.fileNames.join(", ") || "Ukjent kildefil"}
            </Text>
          ))}
        </div>
      </details>
    </Alert>
  );
};
